import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import EditSectionDropdown from '../../../../presentation/EditSectionDropdown';
import EtelAPI from '../../../../api/EtelAPI';
import Alerts from '../../../../prototypes/Alerts';
import Overlay from '../../../../presentation/Overlay';


import {
  Dialog,
  DialogHeader,
  DialogBody,
  DialogFooter,
} from '../../../../presentation/Dialog';



class ServerRouting extends React.Component{

  constructor( props ){
    super( props );

    this.state = {
      newServer: '',
      primaryServer: null,
      servers: null,
      ready: false,
      primaryServerState: null,
      showdialog: false,
      showinfo: false,
    };

    this.dropDownChange = this.dropDownChange.bind( this );
    this.getServers = this.getServers.bind( this );
    this.getPrimaryServer = this.getPrimaryServer.bind( this );
    this.setServerSettings = this.setServerSettings.bind( this );
    this.onConfirm = this.onConfirm.bind( this );
    this.onCancel = this.onCancel.bind( this );
    this.saveConfigServer = this.saveConfigServer.bind( this );
    this.onClickIcon = this.onClickIcon.bind( this );
    this.onClickRefreshIcon = this.onClickRefreshIcon.bind( this );
    this.onHandleException = this.onHandleException.bind( this );
  }

  /* Change that occurs on the dropdown */
  dropDownChange( e ){
    this.setState( {newServer:e.target.value} );
  }


  componentDidMount(){
    this.setServerSettings( 0 );
  }

  getServers(){
    return new Promise( function( resolve, reject ) {
      let endpoint = '/serverrouting/servers';
      let api = new EtelAPI( endpoint );
      api.uri = endpoint;
      api.get( {} ).then( ( result ) => {
        resolve( result );
      } ).catch( ( error ) => {
        reject( error );
      } );
    } );
  }

  getPrimaryServer(){
    return new Promise( function( resolve, reject ) {
      let endpoint = '/serverrouting/primaryserver';
      let api = new EtelAPI( endpoint );
      api.uri = endpoint;
      api.get( {} ).then( ( result ) =>{
        resolve( result );
      } ).catch( ( error ) =>{
        reject( error );
      } );
    } );
  }

  saveConfigServer( parameters ){
    return new Promise( function( resolve, reject ) {
      let endpoint = '/serverrouting';
      let api = new EtelAPI( endpoint );
      api.uri = endpoint;
      api.update( parameters ).then( ( result ) => {
        resolve( result );
      } ).catch( ( error ) => {
        reject( error );
      } );
    } );
  }

  onHandleException( exception ){
    const { dispatch } = this.props;
    const Bugsnag = this.props.bugsnag;
    const alerts = new Alerts( Bugsnag, dispatch );    
    const status = exception.status === undefined ? 0 : exception.status;
    if( status === 410 ) {
      alerts.INFO( 'Server Routing', 'Your session has expired.' , 5000 );
    } else if( status === 500 ) {
      alerts.INFO( 'Server Routing', exception.statusText , 5000 );
    } else {
      alerts.CRITICAL( 'Server Routing', exception.statusText );
    }
  }

  setServerSettings( alert ){
    const { dispatch } = this.props;
    const Bugsnag = this.props.bugsnag;
    const alerts = new Alerts( Bugsnag, dispatch );
    this.getServers().then( ( result ) => {
      const serversObj = result;
      this.getPrimaryServer().then( ( result ) => {
        if( alert === 1 ){
          alerts.SUCCESS( 'Server Routing', 'Server status successfully refreshed', 1500 );
        }
        this.setState( { 
          primaryServer: result[0]['PRIMARY_SERVER'], 
          servers: serversObj, 
          primaryServerState: result[0]['SERVER_STATE'], 
          ready: true ,
          newServer: serversObj[0]['ServerName']
        } );
      } ).catch( ( exception ) => {
        this.onHandleException( exception );
      } );
    } ).catch( ( exception ) => {
      this.onHandleException( exception );
    } );
  }

  switchServer( newServer ){
    const { dispatch } = this.props;
    const Bugsnag = this.props.bugsnag;
    const alerts = new Alerts( Bugsnag, dispatch );
    let parameters = {
      'CONFIG_SERVER_FLAGS_ID': 1,
      'SVR': 'Enterprise',
      'SERVER_STATE': this.returnServerState( this.state.servers, newServer ),
      'QUE_SECONDS': 30,
      'PRIMARY_SERVER_NAME': newServer,
      'FORCE_ROLL_BACK': 0
    };

    this.saveConfigServer( parameters ).then( ( result ) => {
      this.setState( { showdialog: false } );
      this.setServerSettings();
      alerts.SUCCESS( 'Server Routing', 'Server routing successful!', 3000 );
    } ).catch( ( exception ) => {
      this.onHandleException( exception );
    } );

  }

  createDropdownList( arrayList ){
    let newList = [];
    for ( var i = 0; i < arrayList.length; i++ ){
      let item = arrayList[i];
      newList.push( { 'id': item.ServerName, 'text': item.ServerName, 'server_state': item.SERVER_STATE } );
    }
    return newList;
  }


  returnStatus( state ){
    if( state === 1 ){
      return 'Online';
    }else if( state === 0 ){
      return 'Down';
    }else{
      return 'Unknown';
    }
  }

  returnServerState( serverObj, serverName ){
    for( var i = 0; i < serverObj.length; i++ ){
      let item = serverObj[i];
      if( item.ServerName === serverName ){
        return item.SERVER_STATE;
      }
    }
    return 2;
  }

  onConfirm( e ){
    this.setState( { showdialog: true } );
  }

  onCancel( e ){
    this.setState( { showdialog: false } );
  }

  onClickIcon( e ){
    let showinfo = this.state.showinfo;
    this.setState( { showinfo: !( showinfo )} );
  }

  onClickRefreshIcon( e ){
    this.setServerSettings( 1 );
  }

  render(){
    let options = [];
    let newOption = this.state.newServer;
    let servers = this.state.servers;
    let statusCurrent = 'Unknown';
    let showinfo = 'hidden';
    let displayinfo = '';
    let buttonBlock = '';

    if( this.state.ready === true ){
      if( servers !== null && servers !== undefined ){
        if( servers.length > 0 ){
          options = this.createDropdownList( servers );  
          buttonBlock = (
            <div style={{'height': '50%','display':'flex','alignItems':'center','justifyContent':'center'}}>
              <button className="switch-delete-button" onClick={this.onConfirm}>SWITCH SERVER</button>
            </div>
          );
        }
      }

      //Upon initial loading, use the first server returned from the backend
      if ( this.state.newServer === '' ){
        newOption = servers[0]['ServerName'];
      }

      //Return the state for the picked server
      statusCurrent = this.returnStatus ( this.returnServerState( servers, newOption ) );

      //Return the state for the primary server
      let statusPrimary = this.returnStatus( this.state.primaryServerState );

      if( this.state.showinfo === true ){
        showinfo = 'visible';
        displayinfo = 'Click the Icon to Close Information ';
      } else {
        showinfo = 'hidden';
        displayinfo = 'Click the Icon For More Information ';
      }

      return(
        <span className="server-routing-page">
          <div style={{'height': '35%'}}>
            <p style={{'textAlign':'center','fontSize':'25px','padding':'10px','margin':'0'}}>{'Rate Call Server Routing'}</p>
            <div style={{'textAlign':'center','fontSize':'15px'}}>{ displayinfo }<i onClick={this.onClickIcon} style={{'cursor':'pointer','fontSize':'1.15em'}} className={'icon-dripicons-information'} /></div>
            <div className="info-box" style={{'visibility': showinfo, 'textAlign':'center','marginTop':'5px'}}>
              <div><p><b>{ 'About "Rate Call Server Routing"' }</b></p></div>
              <div>{ 'This page allows you to choose a server to host Rate Call.'}</div>
              <div>{ 'The field Current Server is the primary server that is currently hosting Rate Call.'}</div>
              <div>{ 'Servers to route to are populated in the dropdown if it follows this requirement: The stored procedure sp_SERVER_SystemCheck_SYSTEMNAME MUST exist.'}</div>
              <div>{ 'This stored procedure monitors the server to determine if it is up/down, online, etc.'}</div>
              <div>{ 'This stored procedure then updates the table Config_Server_Flags appropriately.'}</div>
            </div>
          </div>
          <div className="grid-wrapper">
            <div className="grid-header">{'Refresh Status  '}<i onClick={this.onClickRefreshIcon} style={{'cursor':'pointer','fontSize':'1.2em','color':'green'}} className={'icon-flatline-refresh'} /></div>
            <div className="grid-row">
              <div style={{'width':'100%','height':'100%','display':'flex','alignItems':'center','justifyContent':'flex-end'}}>
                <div style={{'fontSize':'18px', 'marginRight':'15%'}}>
                  {'Current Server: ' + this.state.primaryServer}
                </div>
              </div>
              <div style={{'width':'100%','height':'100%','display':'flex','alignItems':'center','justifyContent':'flex-start'}}>
                <div style={{'fontSize':'18px', 'marginLeft':'15%'}}>
                  {'Status: ' + statusPrimary }
                </div>
              </div>
            </div>
            <div className="grid-row">
              <div style={{'width':'100%','height':'100%','display':'flex','alignItems':'center','justifyContent':'flex-end'}}>
                <div style={{'fontSize':'18px', 'marginRight':'15%','width':'100%','textAlign':'right'}}>
                  {'Server To Route To:    '}
                  <EditSectionDropdown id='header-view-nt-dropdown' width="20%" options={options} value={newOption} onChanged={this.dropDownChange} />
                </div>
              </div> 
              <div style={{'width':'100%','height':'100%','display':'flex','alignItems':'center','justifyContent':'flex-start'}}>
                <div style={{'fontSize':'18px', 'marginLeft':'15%'}}>
                  {'Status: ' + statusCurrent}
                </div>
              </div>
            </div>
          </div>
          <div style={{'height':'20%'}}>
            { buttonBlock }
          </div>
          <Dialog width={40} height={30} show={this.state.showdialog} >
            <DialogHeader caption={'SWITCHING SERVERS'} closeButton onClose={this.onCancel} />
            <DialogBody>
              <div style={{'padding':'2%'}}>
                {'You are attempting to switch the primary server from ' + this.state.primaryServer + ' to ' + newOption + '. Do you want to proceed with the switch?'}
              </div>
            </DialogBody>
            <DialogFooter className={'dialog-footer'}>
              <button className='switch-cancel-button' style={{'fontSize':'10pt'}} key='btnCancel' onClick={this.onCancel}>CANCEL</button>
              <button className='switch-confirm-button' style={{'fontSize':'10pt'}} key='btnConfirm' onClick={this.switchServer.bind( this, newOption )}>CONFIRM</button>
            </DialogFooter>
          </Dialog>
          <Overlay show={this.state.showdialog} />
        </span>
      );
    }else{
      return(
        <span></span>
      );
    }
  }
}


export default withRouter(
  connect (
    ( store ) => {
      return {
        auth: store.auth.auth,
        bugsnag: store.bugsnag.Bugsnag,
        user: store.user.user
      };
    }
  )( ServerRouting ) );



// WEBPACK FOOTER //
// ./src/content/technical/serverrouting/components/ServerRouting.js